import { push } from 'connected-react-router';

import { getContact } from 'common/api/v1/contacts';

import * as createContactModalActions from '../../createContactModal/actions';
import {
    FETCH_CONTACT,
    FETCH_CONTACT_FAILURE,
    FETCH_CONTACT_SUCCESS,
} from '../actionTypes';
import { contactFileActions } from '../reducer';

export default (uid, displayLoading = true, initForm = false) =>
    (dispatch) => {
        if (displayLoading) {
            dispatch(contactFileActions[FETCH_CONTACT]());
        }

        getContact(uid)
            .then((response) => {
                dispatch(
                    contactFileActions[FETCH_CONTACT_SUCCESS](
                        response.data.data,
                    ),
                );
                if (initForm)
                    dispatch(
                        createContactModalActions.prepareUpdate(
                            response.data.data,
                        ),
                    );
            })
            .catch((error) => {
                dispatch(push('/contacts'));
                dispatch(
                    contactFileActions[FETCH_CONTACT_FAILURE](
                        error?.response?.data?.errors,
                    ),
                );
            });
    };
